import { HttpService } from './https.service';
import { BASE_URL } from '../../config/config';
import { CreateOrder } from 'custom-type';
// import { ClanShopCreateOrder } from 'custom_type';

const http = new HttpService();

export class PaymentGatewayService {

    async createOrder(data: CreateOrder):Promise<any> {
        const path = BASE_URL + '/create/order';
        try {
            const response = await http.postRequest(path, data, null);
            return response;
        } catch (error) {
            throw new Error(`Create Plan Service :: ${error}`)
        }
    };
    
    async updateOrderDetail(data: any) {
        const path = BASE_URL + '/payment/info';
        try {
            const response = await http.postRequest(path, data, null);
            return response;
        } catch (error) {
            throw new Error(`Create Plan Service :: ${error}`)
        }
    }

    async createAutoSubscription(data: any):Promise<any> {
        const path = BASE_URL + '/create/auto/subscription';
        try {
            const response = await http.postRequest(path, data, null);
            return response;
        } catch (error) {
            throw new Error(`Create Influencer Auto Subscription Service :: ${error}`)
        }
    };

    async getSubscriptionPaymentInfo(data: any) {
        const path = BASE_URL + '/subscription/payment/info';
        try {
            const response = await http.postRequest(path, data, null);
            return response;
        } catch (error) {
            throw new Error(`Create Plan Service :: ${error}`)
        }
    }

    async clanShopCreateOrder(data: any):Promise<any> {
        const path = BASE_URL + '/clanshop/create/order';
        try {
            const response = await http.postRequest(path, data, null);
            return response;
        } catch (error) {
            throw new Error(`Create Plan Service :: ${error}`)
        }
    };

    async clanShopUpdateOrderDetail(data: any):Promise<any> {
        const path = BASE_URL + '/clanshop/payment/info';
        try {
            const response = await http.postRequest(path, data, null);
            return response;
        } catch (error) {
            throw new Error(`Create Plan Service :: ${error}`)
        }
    };

    // The checkout's billing-state step (API api/billing/billing-state.ts): whether
    // the paying account's own location has its state (`required` when not), and
    // saving it. `key`: the app's web checkout, which has no login token.
    async billingStateStatus(data: { account_id: number; key?: string }): Promise<any> {
        const path = BASE_URL + '/billing/state/status';
        try {
            return await http.postRequest(path, data, null);
        } catch (error) {
            throw new Error(`billingStateStatus :: ${error}`);
        }
    }

    async saveBillingState(data: { account_id: number; state_id: number; key?: string }): Promise<any> {
        const path = BASE_URL + '/billing/state';
        try {
            return await http.postRequest(path, data, null);
        } catch (error) {
            throw new Error(`saveBillingState :: ${error}`);
        }
    }

    // To fetch orders confirmed page details
    async getConfirmedOrderDetails(payment_id: string | number) {
        try {
            const path = BASE_URL + `/orders/confirmed?payment_id=${payment_id}`;
            const response = await http.getRequest(path, null);
            return response;
        } catch (error) {
            throw new Error(`getConfirmedOrderDetails :: ${error}`);
        }
    }

    // To fetch order details
    async getOrderDetails(payment_id: string | number, razorpay_subscription_id: string) {
        try {
            const path = BASE_URL + `/order/details?payment_id=${payment_id}&provider_subscription_id=${razorpay_subscription_id}`;
            const response = await http.getRequest(path, null);
            return response;
        } catch (error) {
            throw new Error(`getOrderDetails :: ${error}`);
        }
    }

}